import { DefaultService } from '@/services/DefaultService';

export default class EtapaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(etapa) {
        return this._http.post(`${this._env}/ven/etapa`, etapa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateOrdem(etapas) {
        return this._http.post(`${this._env}/ven/etapa/updateordem`, etapas, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/ven/etapa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/ven/etapa/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(idFunil, column = 'ordem', order = 'asc', ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/etapa.json?&column=${column}&order=${order}&idFunil=${idFunil}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(idFunil, situacao, ...params) {
		return this._http.get(encodeURI(`${this._env}/ven/etapa/getcombo.json?param=${params}&idFunil=${idFunil}&situacao=${situacao}`), this._headers).then(res => {
				return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}
}